import type { RouteRecordRaw } from 'vue-router'
import { ROUTES } from '@/router/routes.enum'
import { ACTION_ROLES } from '@/utils/constants'
import { redirectIfAuthenticated, requireAuthenticatedUser } from '@/router/guards'

export const authRoutes: RouteRecordRaw[] = [
  {
    path: '/sign_in',
    name: ROUTES.SIGN_IN,
    beforeEnter: redirectIfAuthenticated,
    component: () => import('@/modules/auth/views/SignIn.view.vue'),
    meta: { redirectNotification: 'You are already signed in' }
  },
  {
    path: '/sessions/magic_link/verify',
    name: ROUTES.SEND_MAGIC_LINK,
    beforeEnter: redirectIfAuthenticated,
    component: () => import('@/modules/auth/views/MagicLink.view.vue'),
    meta: { redirectNotification: 'Cannot use a magic link when already signed in' }
  },
  {
    path: '/invite/set_password',
    name: ROUTES.INVITE_SET_PASSWORD,
    beforeEnter: redirectIfAuthenticated,
    component: () => import('@/modules/auth/views/SetPassword.view.vue'),
    meta: { redirectNotification: 'You cannot accept a new user invitation when already signed in' }
  },
  {
    path: '/invite/add_authenticator',
    name: ROUTES.INVITE_ADD_AUTHENTICATOR,
    beforeEnter: requireAuthenticatedUser,
    component: () => import('@/modules/auth/views/AddAuthenticator.view.vue'),
    meta: { roles: ACTION_ROLES.INVITE_ADD_AUTHENTICATOR }
  },
  {
    path: '/invite/add_passkey',
    name: ROUTES.INVITE_ADD_PASSKEY,
    beforeEnter: requireAuthenticatedUser,
    component: () => import('@/modules/auth/views/AddPasskey.view.vue'),
    meta: { roles: ACTION_ROLES.INVITE_ADD_PASSKEY }
  },
  {
    path: '/user_sessions/auto_sign_in',
    name: ROUTES.AUTO_SIGN_IN,
    beforeEnter: requireAuthenticatedUser,
    component: () => import('@/modules/auth/views/AutoSignIn.view.vue'),
    meta: { roles: ACTION_ROLES.AUTO_SIGN_IN }
  },
  {
    path: '/password/reset',
    name: ROUTES.SEND_RESET_PASSWORD_INSTRUCTIONS,
    beforeEnter: redirectIfAuthenticated,
    component: () => import('@/modules/auth/views/SendResetPasswordInstructions.view.vue'),
    meta: {
      redirectNotification: 'Use the Password & Security page to reset your password when already signed in'
    }
  },
  {
    path: '/password/new',
    name: ROUTES.RESET_PASSWORD,
    beforeEnter: redirectIfAuthenticated,
    component: () => import('@/modules/auth/views/ResetPassword.view.vue'),
    meta: {
      redirectNotification: 'Use the Password & Security page to reset your password when already signed in'
    }
  }
]

/** Child route under app shell (sign out) */
export const authChildRoutes: RouteRecordRaw[] = [
  {
    path: '/sign_out',
    name: ROUTES.SIGN_OUT,
    component: () => import('@/modules/auth/views/SignOut.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.SIGN_OUT }
  }
]
